import AccountingUsersPage from './AccountingUsersPage';

export default AccountingUsersPage;
